import React, { useState, useEffect } from "react";
import classes from "./NavBar.module.css";
import { NavLink } from "react-router-dom";
import { Logo } from "../../Assets";
import NavItem from "./NavItem/NavItem";
import Dropdown from "./Dropdown/Dropdown";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const isTop = window.scrollY < 60;
      setScrolled(!isTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const packageItems = [
    { link: "/packages", label: "Packages" },
    { link: "/vendors", label: "Preferred Vendors" },
    { link: "/rentals", label: "Rental Equipment" },
  ];

  const bookingItems = [
    { link: "/booking", label: "Pretty Bird Availability/Booking" },
    { link: "/lodging", label: "Robin's Roost Lodging" },
  ];

  const closeDropdown = () => setActiveMenu(null);

  return (
    <nav onMouseLeave={closeDropdown}>
      <ul
        className={
          scrolled ? `${classes.Navbar} ${classes.scrolled}` : classes.Navbar
        }
      >
        {/* HOME */}
        <div onMouseEnter={closeDropdown}>
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? `${classes.active} homeLink` : "homeLink"
            }
          >
            <img src={Logo} alt="Home" />
          </NavLink>
        </div>

        {/* PACKAGES DROPDOWN */}
        <div
          className={classes.navWrapper}
          onMouseEnter={() => setActiveMenu("packages")}
        >
          <NavItem link="/packages" scrolled={scrolled}>
            PACKAGES <i className="fas fa-chevron-down"></i>
          </NavItem>
          {activeMenu === "packages" && (
            <Dropdown
              scrolled={scrolled}
              offHover={closeDropdown}
              items={packageItems}
            />
          )}
        </div>

        {/* LOCATION */}
        <div onMouseEnter={closeDropdown}>
          <NavItem link="/location" scrolled={scrolled}>
            LOCATION
          </NavItem>
        </div>

        {/* PHOTOS */}
        <div onMouseEnter={closeDropdown}>
          <NavItem link="/photos" scrolled={scrolled}>
            PHOTOS
          </NavItem>
        </div>

        {/* BOOKING & LODGING DROPDOWN */}
        <div
          className={classes.navWrapper}
          onMouseEnter={() => setActiveMenu("booking")}
        >
          <NavItem link="/booking" scrolled={scrolled}>
            AVAILABILITY <i className="fas fa-chevron-down"></i>
          </NavItem>
          {activeMenu === "booking" && (
            <Dropdown
              scrolled={scrolled}
              offHover={closeDropdown}
              items={bookingItems}
            />
          )}
        </div>

        {/* FAQ */}
        <div onMouseEnter={closeDropdown}>
          <NavItem link="/faq" scrolled={scrolled}>
            FAQ/RULES
          </NavItem>
        </div>
      </ul>
    </nav>
  );
};

export default Navbar;
